export enum paymentTypeEnum {
  网拍 = 1,
  市场拿货 = 2,
  普通账期 = 4,
  阿里账期 = 11,
  货到转账 = 15,
  转账发货 = 16,
  跨境宝 = 18,
}
